import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  avatarImage: {
    borderRadius: "50%",
    width: "75px",
    height: "75px",
  },
  right: {
    marginLeft: theme.spacing(12),
  },
}));

export default function AvatarCard({ image, name, profession, avatarAtRight }) {
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={3}
      direction="column"
      alignItems="center"
      justify="center"
    >
      <Grid item xs={12} className={avatarAtRight ? classes.right : null}>
        <Avatar className={classes.avatarImage} src={image} alt={name} />
      </Grid>
      <Grid item xs={12}>
        <Typography
          align="center"
          color="secondary"
          variant="body1"
          component="h3"
        >
          {name}
        </Typography>
        <Typography align="center" color="secondary" variant="body2">
          {profession}
        </Typography>
      </Grid>
    </Grid>
  );
}
